import styleInject from '../../external/style-inject/dist/style-inject.es.js';

var css_248z = ".ProgressBar-module_progressBarWrapper__KEX6d {\n  width: 100%;\n  height: 6px;\n  border-radius: 20px;\n  background-color: rgba(9, 10, 11, 0.05);\n}\n\n.ProgressBar-module_progressBar__NNZMH {\n  height: 100%;\n  border-radius: 20px;\n  background-color: #00cc99;\n  transition: width 0.5s;\n}";
var styles = {"progressBarWrapper":"ProgressBar-module_progressBarWrapper__KEX6d","progressBar":"ProgressBar-module_progressBar__NNZMH"};
styleInject(css_248z);

export { styles as default };
